import {getS2aAwsStage} from './ocStageUtil'

const FLASH_LOGIN_BASE_URLS = {
    prod: 'https://productiontools.krones.world/login',
    test: 'https://productiontools.test.krones.world/login',
    dev: 'https://productiontools.dev.krones.world/login'
} as const

export function buildFlashLoginUrl(accountId?: string): string {
    const stage = getS2aAwsStage()
    const baseUrl = FLASH_LOGIN_BASE_URLS[stage]

    if (!accountId) {
        return baseUrl
    }

    const accountQuery = encodeURIComponent(accountId)
    return `${baseUrl}?account=${accountQuery}`
}
